// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2QcGg","inner":"Footer_inner__3actH","nextIcon":"Footer_nextIcon__14sW5","innerLeft":"Footer_innerLeft__bZc5k"};